import { GLOBAL_NAME } from '../constants/Globals';
import { CHANGE_CALL_PROVIDER } from '../constants/EventListeners';
export function triggerHostMessageChangeCallProvider(data) {
  if (window[GLOBAL_NAME].triggerEvent) {
    window.hsCalling.triggerEvent({
      event: CHANGE_CALL_PROVIDER,
      data
    });
  }
}